import { render } from "./MyApprovalStaff.vue?vue&type=template&id=01691438"
import script from "./MyApprovalStaff.vue?vue&type=script&lang=js"
export * from "./MyApprovalStaff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__